import { useLoaderData } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { LiveSeoPage } from "~/components/live-seo/LiveSeoPage";

export function LiveSeoRoute(): ReactNode {
	const page = useLoaderData({ from: "/$slug" });

	return <LiveSeoPage page={page} />;
}
